import React from 'react';
import paw from '../../assets/shapes/modal-paw.svg';

const Modal = (props) => {
    return (
        <div id={`${props.id}`} style={{display: props.open ? 'inherit' : 'none'}} className={`modal`}>
            <div  onClick={() => {props.setModalOpened(false)}} className={`modal__overlay ${props.hideOverlay ? 'modal__overlay--hidden' : ''} ${props.overlayClasses??''}`}>
                <img src={paw} alt="paw" className={`modal__paw ${props.hidePaw ? 'modal__paw--hidden' : ''} ${props.pawClasses??''}`} />
            </div>
            <div className={`modal__content  ${props.modalClasses??''}`}>
                {props.children}
            </div>
        </div>
    );
}

export default Modal;